'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setMaxProducts = exports.init = exports.removeEmptyPacks = exports.isSubscriptionCart = exports.updateCartUI = exports.cartContentFadeOut = exports.getCartContents = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _LazyLoader = require('scripts/components/LazyLoader');

var _AddToCart = require('scripts/components/AddToCart');

var _Helpers = require('scripts/components/Helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var packsToRemove = 0;
var itemsWithMax = {
  'Travel Kit': 3
};

var dom = {
  cartContainer: '[cart-container]',
  cartContents: '[cart-contents]',
  checkoutBtn: '[href="/checkout"]',
  timeShipment: '[data-time-shipment]',
  loadBtn: '[load-btn], .carthook_checkout',
  inlineCartUpsells: '[cart-upsells]',
  inlineCartContents: '[data-inline-cart] [cart-contents]'
};

var getIsCartTemplate = function getIsCartTemplate() {
  return $('body').hasClass('template__cart');
};

var getCartViewAffix = function getCartViewAffix() {
  return getIsCartTemplate() ? 'contents' : 'inline-cart-contents';
};

var getCartData = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    var url;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = '//' + window.location.host + '/cart?view=' + getCartViewAffix();
            _context.next = 3;
            return fetch(url, { credentials: 'same-origin', cache: 'no-store' }).then(function (res) {
              return res.text();
            });

          case 3:
            return _context.abrupt('return', _context.sent);

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function getCartData() {
    return _ref.apply(this, arguments);
  };
}();

var getCartContents = exports.getCartContents = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getCartData().then(function (response) {
              if (getIsCartTemplate()) {
                $(dom.cartContents).html(response);
                return response;
              } else {
                var res = $('<div />').html(response);
                $(dom.cartContents).html(res.find('[data-inline-cart-main]').html());
                $(dom.inlineCartUpsells).html(res.find('[data-inline-cart-upsell]').html());
                cartContentFadeIn();
                return response;
              }
            });

          case 2:
            return _context2.abrupt('return', _context2.sent);

          case 3:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function getCartContents() {
    return _ref2.apply(this, arguments);
  };
}();

var cartContentFadeIn = function cartContentFadeIn() {
  $(dom.inlineCartContents).fadeTo(200, 1);
  $(dom.inlineCartUpsells).fadeTo(200, 1);
};

var cartContentFadeOut = exports.cartContentFadeOut = function cartContentFadeOut() {
  $(dom.inlineCartContents).fadeTo(200, 0);
  $(dom.inlineCartUpsells).fadeTo(200, 0);
};

var updateCartUI = exports.updateCartUI = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(state) {
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getCartContents().then(function (response) {
              (0, _LazyLoader.update)();
              $(dom.cartContainer).removeClass('is-loading');
              var event = new CustomEvent('cart.ui.updated');
              document.dispatchEvent(event);
              return state;
            });

          case 2:
            return _context3.abrupt('return', _context3.sent);

          case 3:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, undefined);
  }));

  return function updateCartUI(_x) {
    return _ref3.apply(this, arguments);
  };
}();

var isSubscriptionCart = exports.isSubscriptionCart = function isSubscriptionCart() {
  return window.bva.cart.items.some(function (item) {
    return item.properties && typeof item.properties.shipping_interval_frequency !== 'undefined';
  });
};

var addCouponCode = function addCouponCode() {
  var couponCode = _jsCookie2.default.get('bva-cart-coupon-code') || false;
  if (!couponCode) {
    return;
  }

  window.chCouponCode = couponCode;
};

var activateCart = function activateCart() {
  packsToRemove--;
  if (packsToRemove <= 0) {
    window.location.reload();
  }
};

var removeEmptyPacks = exports.removeEmptyPacks = function removeEmptyPacks(cart) {
  var keyToRemove = cart.items.reduce(function (key, item) {
    if (item.product_title.includes('Pack') || item.handle.includes('pack') || item.handle.includes('set')) {
      var _item$properties = item.properties,
          properties = _item$properties === undefined ? {} : _item$properties;

      var _ref4 = properties || {},
          _ref4$pack_id = _ref4.pack_id,
          pack_id = _ref4$pack_id === undefined ? false : _ref4$pack_id;

      if (!pack_id) {
        key = item.key;
      }
    }
    return key;
  }, 0);
  if (keyToRemove) {
    if (getIsCartTemplate()) (0, _AddToCart.cartRemove)(keyToRemove).then(updateCartUI);else return (0, _defineProperty3.default)({}, keyToRemove, 0);
  }
};

var removeIncompletePacks = function removeIncompletePacks() {
  var cartRequest = $.get('/cart.js');
  cartRequest.done(function (response) {
    var cart = JSON.parse(response);
    var packs = cart.items.reduce(function (items, item) {
      if (item.properties != null && item.properties.hasOwnProperty('pack_id')) {
        var packId = item.properties.pack_id;
        var packCount = parseInt(item.properties.pack_count);
        var itemCount = cart.items.reduce(function (count, lineItem) {
          if (lineItem.properties != null && lineItem.properties.hasOwnProperty('pack_id') && lineItem.properties.pack_id === packId) {
            return count + 1;
          }
          return count;
        }, 0);

        if (itemCount < packCount && (items.length === 0 || items.filter(function (pack) {
          return pack === packId;
        }).length === 0)) {
          items.push(packId);
        }
      }
      return items;
    }, []);

    packsToRemove = packs.length;

    if (packsToRemove < 1) {
      updateCartUI();
      return;
    }

    packs.forEach(function (pack) {
      (0, _AddToCart.cartRemovePack)(pack).then(activateCart).catch(console.error);
    });
  });
  cartRequest.fail(function () {
    updateCartUI();
  });
};

// Hide any items that were replaced by packs BUT replacement request
// wasn't as fast as cart redirect
var hideRemovedItems = function hideRemovedItems() {
  // consume instead of get since we don't want to hide future products of type
  var itemsToRemove = (0, _Helpers.consumeSessionStorage)('removedByPackUpsell');
  if (itemsToRemove) {
    var allIDs = JSON.parse(itemsToRemove);
    allIDs.forEach(function (itemToRemove) {
      var toRemove = document.querySelector('[line-item-id="' + itemToRemove + '"]');
      if (toRemove) {
        toRemove.style.display = 'none';
      }
    });
  }
};

var init = exports.init = function init() {
  hideRemovedItems();
  addCouponCode();
  removeIncompletePacks();
  removeEmptyPacks(window.bva.cart);
  bindUIActions();
};

// when a user hits the cart page, need to enforce max number of some products
var setMaxProducts = exports.setMaxProducts = function () {
  var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
    return _regenerator2.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            window.bva.cart.items.forEach(function (item) {
              var vendorMax = itemsWithMax[item.vendor] || false;
              var isPackItem = item.properties !== null ? item.properties.hasOwnProperty('pack_id') : false;
              var isPackParent = isPackItem && item.price === 0;
              if (vendorMax && isPackParent) {
                var productCount = item.quantity;
                var packId = item.properties.pack_id;
                if (productCount > vendorMax) {
                  return (0, _AddToCart.cartUpdatePack)(packId, vendorMax).then(updateCartUI).catch(console.error);
                }
              }
            });

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, undefined);
  }));

  return function setMaxProducts() {
    return _ref6.apply(this, arguments);
  };
}();

var bindUIActions = function bindUIActions() {
  $(document).on('click touchstart', dom.loadBtn, function (event) {
    var $this = $(event.currentTarget);
    $this.addClass('is-loading');
    window.addEventListener('beforeunload', function () {
      $this.removeClass('is-loading').addClass('is-success');
    });
  });

  $(document).on('change', '[gift-order-input]', function (event) {
    var $this = $(event.currentTarget);
    var isChecked = $this.is(':checked');
    var note = isChecked ? $this.val() : null;
    $.post('/cart/update.js', { note: note }).then(function (cart) {
      return JSON.parse(cart);
    }).then(function (cart) {
      $('[data-carthook-note]').val(cart.note);
      window.bva.cart = cart;
    });
  });

  document.addEventListener('cart.updated', function (event) {
    var cart = event.detail || false;
    if (cart) updateCartUI(cart);
  });
};